<template>
    <div style="background-color:white">
        <div class="col-md-12" style="margin-top:20px">
            <div class="col-md-6">
                <h3 class="page-header">
                    <i class="fa fa fa-users animated bounceInDown show-info"></i>
                    Add Customer
                </h3>
            </div>
        </div>
        <div class="info-box  bg-seagreen  text-white">
            <div class="info-icon bg-danger-dark">
                <i class="fa fa fa-user fa-2x"></i>
            </div>
            <div class="info-details">
                <h4>Add Customer Personal Details</h4>
            </div>
        </div>

        <form class="col-md-12" :key="formresetkey" @submit.prevent="submit" @keydown="keydownform($event)">

            <div class="panel panel-cascade">
                <div class="panel-body">
                    <div class="form-horizontal cascde-forms">

                        <div class="form-group row Authority" style="">
                            <label class="col-lg-4 col-md-3 control-label"></label>
                            <div class="col-lg-4 col-md-4 ">

                                <img :src="profileimageurl" width="100px" height="100px" />
                                <upload></upload>
                            </div>
                        </div>
                        <div class="col-md-10">

                            <referral-selector col="col-lg-3 col-md-3" label="Introducer Id"></referral-selector>

                            <div class="form-group row">
                                <label class="col-lg-4 col-md-3 control-label">Registation Type</label>
                                <div class="col-lg-6 col-md-9">
                                    <select v-model="form.registation_type"
                                        class="form-control delradius form-cascade-control">
                                        <!-- <option v-for="option in getmastertype(MASTER_REGISTRATION_TYPE)"
                                            v-bind:key="option.labelid" v-bind:value="option.labelid"
                                            v-text="option.label" /> -->
                                        <option :value="1" v-if="loginusercheck(127)">Permanent</option>
                                        <option :value="2" v-if="loginusercheck(128)">Temporary</option>
                                        <option :value="3" v-if="loginusercheck(648)">Dummy</option>
                                        <option :value="4" v-if="edititem?.registation_type == 4">App</option>
                                    </select>
                                </div>
                            </div>

                            <div v-if="isDummyRegistration">
                                <div class="form-group row">
                                    <label class="col-lg-4 col-md-3 control-label">Customer Name</label>
                                    <div class="col-lg-6 col-md-9">
                                        <input class="form-control form-cascade-control input-small"
                                            v-model="dummyForm.name" type="text">
                                    </div>
                                </div>
                                 <div class="form-group row">
                                    <label class="col-lg-4 col-md-3 control-label">Mobile No.</label>
                                    <div class="col-lg-6 col-md-9">
                                        <mobiles></mobiles>
                                    </div>
                                </div>
                                <address-form></address-form>
                               
                            </div>

                            <template >
                            <div class="form-group row CHK" v-if="isStandardRegistration">
                                <label class=" col-lg-4 col-md-3 control-label">
                                    Name
                                </label>
                                <div class="col-lg-6 col-md-9">
                                    <input class="form-control form-cascade-control input-small" v-model="form.name"
                                        data-val="true" data-val-required="Required" id="NAME" name="NAME" type="text">
                                </div>
                            </div>
                            <div class="form-group row CHK" v-if="isStandardRegistration">
                                <label class=" col-lg-4 col-md-3 control-label">
                                    <select class="form-cascade-control input-small" style="width:64%;padding:3px;"
                                        v-model="form.relationship_type">
                                        <option v-for="option in getmastertype(MASTER_RELATIONSHIP_TYPES)"
                                            v-bind:key="option.labelid" v-bind:value="option.labelid"
                                            v-text="option.label" />
                                    </select>
                                </label>
                                <div class="col-lg-6 col-md-9">
                                    <input class="form-control form-cascade-control input-small" v-model="form.relation"
                                        id="FATHER_NAME" name="FATHER_NAME" type="text">
                                </div>
                            </div>
                            <div class="form-group row" v-if="isStandardRegistration">
                                <label class="col-lg-4 col-md-3 control-label">Gender</label>
                                <div class="col-lg-6 col-md-9">
                                    <select v-model="form.gender" class="form-control delradius form-cascade-control">
                                        <option v-for="option in getmastertype(MASTER_GENDER)" v-bind:key="option.labelid"
                                            v-bind:value="option.labelid" v-text="option.label" />
                                    </select>
                                </div>
                            </div>
                            <div class="form-group row" v-if="isStandardRegistration">
                                <label class="col-lg-4 col-md-3 control-label">DOB</label>
                                <div class="col-lg-6 col-md-9">
                                    <!-- <input class="form-control form-cascade-control input-small"  v-model="form.dob" id="DOB" name="DOB"  type="date" > -->
                                    <vc-date-picker class="inline-block h-full" :model-config="modelConfig"
                                        v-model="form.dob">
                                        <template v-slot="{ inputValue, togglePopover }">
                                            <div class="flex items-center">
                                                <button type="button" class="date-picker" @click="togglePopover()">
                                                    <i class='bx bx-calendar'></i>
                                                </button>
                                                <input :value="inputValue" @click="togglePopover()"
                                                    class="form-control form-cascade-control input-small"
                                                    placeholder="DD/MM/YYYY" readonly />
                                            </div>
                                        </template>
                                    </vc-date-picker>
                                </div>
                            </div>
                            <address-form v-if="isStandardRegistration"></address-form>

                            <div class="form-group row CHK" v-if="isStandardRegistration">
                                <label class="col-lg-4 col-md-3 control-label">
                                    Zone
                                </label>
                                <div class="col-lg-6 col-md-9">
                                    <select class="form-cascade-control input-small" style="width:64%;padding:3px;"
                                        v-model="form.zoneid">
                                        <option v-for="option in getmastertype(MASTER_ZONE_TYPES)"
                                            v-bind:key="option.labelid" v-bind:value="option.labelid"
                                            v-text="option.label" />
                                    </select>
                                </div>
                            </div>
                            <div class="form-group row" v-if="isStandardRegistration">
                                <label class="col-lg-4 col-md-3 control-label">Add Location Place</label>
                                <div class="col-lg-6 col-md-9">
                                    <input class="form-control form-cascade-control input-small" v-model="form.location"
                                        data-val-required="Required" type="text">
                                </div>
                            </div>
                            <div class="form-group row" v-if="isStandardRegistration">
                                <label class="col-lg-4 col-md-3 control-label">Distance</label>
                                <div class="col-lg-2 col-md-7">
                                    <input class="form-control form-cascade-control input-small" v-model.number="form.distance"
                                        type="number" step="any" min="0" placeholder="Distance">
                                </div>
                                <div class=col-md-2 p-0>KM</div>
                            </div>
                            <div class="form-group row" v-if="isStandardRegistration">
                                <label class="col-lg-4 col-md-3 control-label">Customer Mobile</label>
                                <div class="col-lg-6 col-md-9">
                                    <mobiles></mobiles>
                                </div>
                            </div>

                            <div class="form-group row" v-if="isStandardRegistration">
                                <label class="col-lg-4 col-md-3 control-label">Mode of Re-Payment</label>
                                <div class="col-lg-6 col-md-9">
                                    <select class="form-control form-cascade-control input-small"
                                        v-model="form.paymentmodeid">
                                        <option v-for="item in registers" :key="item.id" :value="item.id">{{ item.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group row" v-if="isStandardRegistration">
                                <label class="col-lg-4 col-md-3 control-label">Nature of Residence</label>
                                <div class="col-lg-6 col-md-9">
                                    <select v-model="form.residence" class="form-control delradius form-cascade-control">
                                        <option :value="0">----Select----</option>
                                        <option v-for="option in getmastertype(MASTER_RESIDENCE)"
                                            v-bind:key="option.labelid" v-bind:value="option.labelid"
                                            v-text="option.label" />
                                    </select>
                                </div>
                            </div>
                            <div class="form-group row" v-if="isStandardRegistration">
                                <label class="col-lg-4 col-md-3 control-label">Duration of Residence</label>
                                <div class="col-lg-6 col-md-9">
                                    <input class="form-control form-cascade-control input-small" v-model="form.dor"
                                        data-val-required="Required" type="number">

                                </div>
                            </div>
                            <div class="form-group row" v-if="isStandardRegistration">
                                <label class="col-lg-4 col-md-3 control-label">Occuption</label>
                                <div class="col-lg-6 col-md-9">
                                    <select v-model="form.s_income" class="form-control delradius form-cascade-control"
                                        required>
                                        <option v-for="option in getmastertype(MASTER_OCCUPATION_TYPE)"
                                            v-bind:key="option.labelid" v-bind:value="option.labelid"
                                            v-text="option.label" />
                                    </select>
                                </div>
                            </div>
                            <div class="form-group row" v-if="isStandardRegistration">
                                <label class="col-lg-4 col-md-3 control-label">Occupation name and Address</label>
                                <div class="col-lg-6 col-md-9">
                                    <input class="form-control form-cascade-control input-small" v-model="form.occupation"
                                        id="OCCUPATION" name="OCCUPATION" type="text" required>
                                </div>
                            </div>
                            <div class="form-group row" v-if="isStandardRegistration">
                                <label class="col-lg-4 col-md-3 control-label">Profession</label>
                                <div class="col-lg-6 col-md-9">
                                    <select v-model="form.professionid" class="form-control delradius form-cascade-control"
                                        required>
                                        <option :value="0">----Select---</option>
                                        <option v-for="option in getcompanymastertype(COMPANY_MASTER_PROFESSION)"
                                            v-bind:key="option.labelid" v-bind:value="option.labelid"
                                            v-text="option.label" />
                                    </select>
                                </div>
                            </div>
                            <div class="form-group row mt-10" >
                                <label class="col-lg-4 col-md-3 control-label">Registration Date</label>
                                <div class="col-lg-6 col-md-9">
                                    <!-- <input class="form-control form-cascade-control input-small" data-val="true"
                                        v-model="form.registation_date" data-val-required="Required" id="REGDATE"
                                        name="REGDATE" type="date"> -->
                                    <span v-if="Number(form.id) > 0" class="form-control-plaintext">
                                        {{ registrationDateLabel }}
                                    </span>
                                    <vc-date-picker v-else class="inline-block h-full" :model-config="modelConfig"
                                        v-model="form.registation_date">
                                        <template v-slot="{ inputValue, togglePopover }">
                                            <div class="flex items-center">
                                                <button type="button" class="date-picker" @click="togglePopover()">
                                                    <i class='bx bx-calendar'></i>
                                                </button>
                                                <input :value="inputValue" @click="togglePopover()"
                                                    class="form-control form-cascade-control input-small"
                                                    placeholder="DD/MM/YYYY" readonly />
                                            </div>
                                        </template>
                                    </vc-date-picker>
                                </div>
                            </div>


                            <work-address-form v-if="form.registation_type == 1"></work-address-form>
                            <div class="form-group row" v-if="form.registation_type == 1">
                                <label class="col-lg-4 col-md-3 control-label">Religion</label>
                                <div class="col-lg-6 col-md-9">
                                    <select v-model="form.religion" class="form-control delradius form-cascade-control"
                                        required>
                                        <option v-for="option in getmastertype(MASTER_RELIGION)" v-bind:key="option.labelid"
                                            v-bind:value="option.labelid" v-text="option.label" />
                                    </select>
                                </div>
                            </div>
                            <div class="form-group row" v-if="form.registation_type == 1">
                                <label class="col-lg-4 col-md-3 control-label">Marital Status</label>
                                <div class="col-lg-6 col-md-9">
                                    <select v-model="form.m_status" class="form-control delradius form-cascade-control"
                                        required>
                                        <option v-for="option in getmastertype(MASTER_MARITAL_STATUS)"
                                            v-bind:key="option.labelid" v-bind:value="option.labelid"
                                            v-text="option.label" />
                                    </select>
                                </div>
                            </div>
                            <div class="form-group row" v-if="form.m_status == 1 && form.registation_type == 1">
                                <label class="col-lg-4 col-md-3 control-label">Marrige Date</label>
                                <div class="col-lg-6 col-md-9">
                                    <!-- <input class="form-control form-cascade-control input-small"
                                        v-model="form.marrigedate" type="date"> -->
                                    <vc-date-picker class="inline-block h-full" :model-config="modelConfig"
                                        v-model="form.marrigedate">
                                        <template v-slot="{ inputValue, togglePopover }">
                                            <div class="flex items-center">
                                                <button type="button" class="date-picker" @click="togglePopover()">
                                                    <i class='bx bx-calendar'></i>
                                                </button>
                                                <input :value="inputValue" @click="togglePopover()"
                                                    class="form-control form-cascade-control input-small"
                                                    placeholder="DD/MM/YYYY" readonly />
                                            </div>
                                        </template>
                                    </vc-date-picker>
                                </div>
                            </div>

                            <div class="form-group row" v-if="isStandardRegistration"
                                :class="{ 'form-group--error': $v.form.adhar.$error }">
                                <label class="col-lg-4 col-md-3 control-label">Adhar Card No.</label>
                                <div class="col-lg-6 col-md-9">
                                    <input class="form-control form-cascade-control input-small" v-model="form.adhar"
                                        data-val-required="Required" type="text">
                                    <i v-if="validateadhar"
                                        class='bx bxs-checkbox-checked bx-tada adhar-validate-success'></i>
                                    <!-- <span class="error" v-if="!$v.form.adhar.required">Field is required</span> -->
                                    <span class="error" v-if="!$v.form.adhar.minLength">Adhar must have
                                        {{ $v.form.adhar.$params.minLength.min }} letters.</span>
                                    <span class="error" v-if="!$v.form.adhar.maxLength">Adhar must have
                                        {{ $v.form.adhar.$params.maxLength.max }} letters.</span>
                                    <!-- <span class="error" v-if="!$v.form.adhar.isUnique">No. of Emi Should not be 0</span> -->
                                </div>
                            </div>
                            <div class="form-group row" v-if="form.registation_type == 1">
                                <label class="col-lg-4 col-md-3 control-label">Pan Card No.</label>
                                <div class="col-lg-6 col-md-9">
                                    <input class="form-control form-cascade-control input-small" v-model="form.pan"
                                        data-val-required="Required" type="text">
                                    <div class="col-md-12 form-error"></div>
                                </div>
                            </div>
                            <div class="form-group row CHK" v-if="form.registation_type == 1">
                                <label class=" col-lg-4 col-md-3 control-label">
                                    <select class="form-cascade-control input-small" style="width:64%;padding:3px;"
                                        v-model="form.document_type">
                                        <option v-for="option in getmastertype(MASTER_DOCUMENT)" v-bind:key="option.labelid"
                                            v-bind:value="option.labelid" v-text="option.label" />
                                    </select>
                                </label>
                                <div class="col-lg-6 col-md-9">
                                    <input class="form-control form-cascade-control input-small"
                                        v-model="form.documentvalue" id="FATHER_NAME" name="FATHER_NAME" type="text">
                                </div>
                            </div>

                            <div class="form-group row" v-if="form.registation_type == 1">
                                <label class="col-lg-4 col-md-3 control-label">Email</label>
                                <div class="col-lg-6 col-md-9">
                                    <input class="form-control form-cascade-control input-small" v-model="form.email"
                                        data-val-required="Required" type="text">
                                    <div class="col-md-12 form-error"></div>
                                </div>
                            </div>
                            <div class="form-group row" v-if="isStandardRegistration">
                                <label class="col-lg-4 col-md-3 control-label">Customer Type</label>
                                <div class="col-lg-6 col-md-9">
                                    <select class="form-control form-cascade-control input-small"
                                        v-model="form.customer_type">
                                        <option value="A">A</option>
                                        <option value="B">B</option>
                                        <option value="C">C</option>
                                        <option value="D">D</option>
                                    </select>
                                    <div class="col-md-12 form-error"></div>
                                </div>
                            </div>
                            <div class="form-group row" v-if="form.registation_type == 1">
                                <label class="col-lg-4 col-md-3 control-label">Credit Limit</label>
                                <div class="col-lg-6 col-md-9">
                                    <input class="form-control form-cascade-control input-small" v-model="form.creditlimit">
                                </div>
                            </div>
                            <div class="form-group row" v-if="isStandardRegistration">
                                <label class="col-lg-4 col-md-3 control-label">Verified By</label>
                                <div class="col-lg-6 col-md-9">
                                    <select v-model="form.verifiedbyid"
                                        class="form-control form-cascade-control input-small">
                                        <option v-for="(item) in employees" v-bind:key="item.id" :value="item.id">
                                            <label for="">{{ item.generatedid }}</label> -{{ item.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group row" v-if="isStandardRegistration">
                                <label class="col-lg-4 col-md-3 control-label">Reference Name</label>
                                <div class="col-lg-6 col-md-9">
                                    <input class="form-control form-cascade-control input-small" type="text"
                                        v-model="form.refername">
                                </div>
                            </div>
                            <div class="form-group row" v-if="isStandardRegistration">
                                <label class="col-lg-4 col-md-3 control-label">Reference Mobile No.</label>
                                <div class="col-lg-6 col-md-9">
                                    <input class="form-control form-cascade-control input-small" type="number"
                                        v-model="form.refermobileno">
                                </div>
                            </div>
                            <div class="form-group row" v-if="isStandardRegistration">
                                <label class="col-lg-4 col-md-3 control-label">Reference Address</label>
                                <div class="col-lg-6 col-md-9">
                                    <textarea class="form-control form-cascade-control input-small"
                                        v-model="form.referaddress" cols="20" rows="2" style="height:83px;"></textarea>
                                </div>
                            </div>
                            <div class="form-group row" v-if="isStandardRegistration">
                                <label class="col-lg-4 col-md-3 control-label">Reference Relationship</label>
                                <div class="col-lg-6 col-md-9">
                                    <input class="form-control form-cascade-control input-small" type="text"
                                        v-model="form.referrelation">
                                </div>
                            </div>
                            <div class="form-group row" v-if="isStandardRegistration">
                                <label class="col-lg-4 col-md-3 control-label">Additional Add. & Other Customer Hint</label>
                                <div class="col-lg-6 col-md-9">
                                    <textarea class="form-control form-cascade-control input-small" v-model="form.cus_hint"
                                        cols="20" id="CUSTHINT" name="CUSTHINT" rows="2" style="height:83px;"></textarea>
                                </div>
                            </div>
                            <div class="form-group row row leadbycustomer" style="display: none">
                                <div class="col-lg-6 col-md-9">
                                    <span id="fill"></span>
                                </div>
                            </div>
                            </template>
                        </div>

                    </div>
                </div>
            </div>
            <div class="panel panel-cascade" style="padding-top:20px">
                <div class="panel-body">
                    <div class="form-horizontal cascde-forms">
                        <div class="col-md-12 row">
                            <id-proof></id-proof>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="flex-around-row" style="text-align:center;">
                    <input v-if="!clickpdf" :readonly="clickpdf" type="button"
                        style="background-color:#495b79!important;margin-top:23px;width:100px" value="Submit"
                        @click="submit()" class="btn bg-primary text-white btn-sm chkcondition">
                    <span v-if="clickpdf" class="spinner"></span>
                    <input type="button" style="background-color:#495b79!important;margin-top:23px;width:100px"
                        value="Cancel" @click="cancel()" class="btn bg-primary text-white btn-sm chkcondition">

                    <!-- <input type="button" style="background-color:#495b79!important;margin-top:23px;width:100px"
                        value="Location" @click="getlocation()" class="btn bg-primary text-white btn-sm chkcondition"> -->
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import AddressForm from '../../components/address/AddressForm.vue'
import WorkAddressForm from '../../components/address/WorkAddressForm.vue'
import Mobiles from '../../components/mobile/Mobiles.vue'
import IdProof from '../../components/idproof/IdProof.vue'
import Constants from '../../components/utilities/Constants.vue'
import Upload from '../../components/upload/Upload.vue'
import ReferralSelector from '../../components/user/ReferralSelector.vue'
import { minLength, maxLength } from 'vuelidate/lib/validators'
export default {
    mixins: [Constants],
    props: ['label'],
    components: { Mobiles, AddressForm, IdProof, Upload, ReferralSelector, WorkAddressForm },
    data() {
        return {
            form: new window.Form({
                id: 0,
                name: '',
                adhar: 0,
                sponser_type: 0,
                registation_type: 0,
                parentid: 0,
                relation: '',
                mobiles: null,
                addressess: null,
                idproofs: null,
                s_income: 1,
                m_status: 1,
                marrigedate: null,
                occupation: '',
                religion: 1,
                gender: 1,
                dob: '',
                registation_date: '',
                relationship_type: 1,
                zoneid: 1,
                location: '',
                distance: 0,
                cus_hint: '',
                document_type: 1,
                iscustomer: 1,
                w_name: '',
                profileimage: null,
                email: '',
                documentvalue: '',
                pan: '',
                residence: 0,
                dor: '',
                customer_type: '',
                creditlimit: '',
                paymentmodeid: 0,
                verifiedbyid: 0,
                latitude: '',
                longitude: '',
                refername: '',
                refermobileno: '',
                referaddress: '',
                referrelation: '',
                professionid: 0
            }),
            modelConfig: {
                type: 'string',
                mask: 'YYYY-MM-DD', // Uses 'iso' if missing
            },
            clickpdf: false,
            validateadhar: true,
            dummyForm: {
                name: '',
                mobile: '',
                altmobile: ''
            },
            dummyMobileDuplicate: false,
            dummyAltMobileDuplicate: false,
            dummyMobileEditing: false,
            dummyAltMobileEditing: false,
            originalDummyMobile: '',
            originalDummyAltMobile: '',
            formresetkey: 0,
            referralPointAmount: 0,
            awardDummyReferralPoints: false
        }
    },
    validations: {
        form: {
            adhar: {
                minLength: minLength(12),
                maxLength: maxLength(12),
            }
        }
    },
    computed: {
        ...mapGetters([
            'perpagerecord', 'viewno', 'edititem', 'profileimage', 'uploadedimage', 'mobiles',
            'addressess', 'referraluser', 'idproofs', 'registers', 'loggedinuser', 'employees', 'uploadids',
            'customers', 'selectedstoreid'
        ]),
        profileimageurl() {
            if (this.profileimage != null) {
                return this.profileimage.fullurl;
            }
            return '#'
        },
        isDummyRegistration() {
            return this.form.registation_type == 3;
        },
        registrationDateLabel() {
            const value = this.form.registation_date;
            if (!value) return 'Not set';
            const date = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
            return date ? `${date[3]}/${date[2]}/${date[1]}` : value;
        },
        isStandardRegistration() {
            // App (4) customers are edited like Temporary ones
            return [1, 2, 4].includes(Number(this.form.registation_type));
        }
        //   mastertypes(){
        //     console.log(this.$store.state.mastertypes)
        // 	return this.$store.state.mastertypes;
        // },


    },
    watch: {
        edititem: {
            immediate: true,
            handler() {
                if (this.$router.currentRoute.path == '/addcustomer') {
                    this.$store.commit("assignedititem", null)
                    this.resetCustomerForm();
                    return
                }
                this.initializedata()
            }
        }
    },
    mounted() {
        this.$store.dispatch("fetchregisters")
        this.$store.dispatch("fetchemployees")
        this.$store.dispatch('fetchcompanymaster')
        this.fetchReferralPointAmount()
        // permission check needs the logged-in user (was a fixed 2s wait)
        this.waitForLoggedInUser().then(() => this.checkvalidationaccess())

        // this.$getLocation(options)
        // .then(coordinates => {
        //     console.log("Cordinates :"+coordinates);
        // });

        this.$getLocation({
            enableHighAccuracy: true, //defaults to false
            timeout: Infinity, //defaults to Infinity
            maximumAge: 10 //defaults to 0
        })
            .then(coordinates => {
                console.log("Cordinates :" + coordinates.lan);
                this.latitude = coordinates.lat
                this.longitude = coordinates.lan
            });
    },
    methods: {
        getlocation() {
            this.$getLocation({
                enableHighAccuracy: true, //defaults to false
                timeout: Infinity, //defaults to Infinity
                maximumAge: 0 //defaults to 0
            })
                .then(coordinates => {
                    console.log("Cordinates :" + (coordinates.accuracy));
                });
        },
        initializedata() {
            //this.reset();
            if (this.edititem != null) {
                console.log("inside edit")
                this.form.id = this.edititem.id;
                this.form.name = this.edititem.name;
                this.form.sponser_type = this.edititem.sponser_type;
                this.form.document_type = this.edititem.document_type
                this.form.documentvalue = this.edititem.documentvalue
                this.form.zoneid = this.edititem.zoneid;
                this.form.location = this.edititem.location
                this.form.distance = this.edititem.distance ?? 0
                this.form.relation = this.edititem.relation;
                this.form.relationship_type = this.edititem.relationship_type;
                this.form.s_income = this.edititem.s_income;
                this.form.occupation = this.edititem.occupation;
                this.form.w_name = this.edititem.w_name;
                this.form.pan = this.edititem.pan;
                this.form.residence = this.edititem.residence;
                this.form.dor = this.edititem.dor;
                this.form.customer_type = this.edititem.customer_type
                this.form.creditlimit = this.edititem.creditlimit
                this.form.religion = this.edititem.religion;
                this.form.paymentmodeid = this.edititem.paymentmodeid
                this.form.verifiedbyid = this.edititem.verifiedbyid
                this.form.gender = this.edititem.gender;
                this.form.dob = this.edititem.dob;
                this.form.registation_type = this.edititem.registation_type;
                this.form.registation_date = this.edititem.registation_date;
                this.form.referrelation = this.edititem.referrelation
                this.form.cus_hint = this.edititem.cus_hint;

                this.form.m_status = this.edititem.m_status;
                this.form.adhar = this.edititem.adhar;
                this.form.email = this.edititem.email;
                this.form.professionid = this.edititem.professionid
                this.form.refername = this.edititem.refername
                this.form.refermobileno = this.edititem.refermobileno
                this.form.referaddress = this.edititem.referaddress
                this.form.referrelation = this.edititem.referrelation
                if (this.edititem.registation_type == 3) {
                    this.dummyForm.name = this.edititem.name ?? '';
                    this.dummyForm.mobile = this.stripCountryCode(this.edititem.mobiles?.[0]?.mobile ?? '');
                    this.dummyForm.altmobile = this.stripCountryCode(this.edititem.mobiles?.[1]?.mobile ?? '');
                    this.originalDummyMobile = this.dummyForm.mobile
                    this.originalDummyAltMobile = this.dummyForm.altmobile
                    this.dummyMobileEditing = false
                    this.dummyAltMobileEditing = false
                } else {
                    this.resetDummyForm();
                }
                this.$store.commit('assignmobiles', this.edititem.mobiles == null ? [] : this.edititem.mobiles)
                this.$store.commit('assignaddressess', this.edititem.addressess == null ? [] : this.edititem.addressess)
                this.$store.commit('assignidproofs', this.edititem.idproofs == null ? [] : this.edititem.idproofs)
                this.$store.commit('assignuploadids', this.edititem.idproofs == null ? [] : this.edititem.idproofs)
                let referraluser = this.edititem.referraluser
                if (referraluser == null && this.edititem.parentid > 0) {
                    referraluser = this.customers.find(block => block.id == this.edititem.parentid) ?? null
                }
                this.$store.commit('assignreferraluser', referraluser)
                if (this.edititem.addressess != null && this.edititem.addressess.length > 0) {
                    let normaladdress = this.edititem.addressess.filter(block => block.addresstype == 0)
                    if (typeof normaladdress !== 'undefined' && normaladdress.length > 0) {
                        this.$store.commit('assignselectedaddress', normaladdress[0])
                    }
                    let workaddress = this.edititem.addressess.filter(block => block.addresstype == 1)
                    if (typeof workaddress !== 'undefined' && workaddress.length > 0) {
                        this.$store.commit('assignselectedwaddress', workaddress[0])
                    }
                }
                if (this.edititem.profileimage != null) {
                    this.form.profileimageid = this.edititem.profileimage.id
                    this.$store.commit('assignprofileimage', this.edititem.profileimage)
                }
            } else {
                this.form = new window.Form({
                    id: 0,
                    name: '',
                    adhar: 0,
                    sponser_type: 0,
                    registation_type: 0,
                    parentid: 0,
                    relation: '',
                    mobiles: null,
                    addressess: null,
                    idproofs: null,
                    zone: '',
                    s_income: 1,
                    m_status: 1,
                    marrigedate: null,
                    occupation: '',
                    religion: 1,
                    gender: 1,
                    dob: '',
                    registation_date: '',
                    cus_hint: '',
                    iscustomer: 1,
                    w_name: '',
                    profileimage: null,
                    email: '',
                    relationship_type: 1,
                    zoneid: 1,
                    location: '',
                    distance: 0,
                    document_type: 1,
                    documentvalue: '',
                    residence: 0,
                    dor: '',
                    customer_type: '',
                    creditlimit: '',
                    paymentmodeid: 0,
                    verifiedbyid: 0,
                    refername: '',
                    refermobileno: '',
                    referaddress: '',
                    referrelation: '',
                    professionid: 0
                })
                this.resetDummyForm()
                this.$store.commit('assignselectedwaddress', null)
                this.$store.commit('assignselectedaddress', null)
                this.$store.commit('assignuploadids', [])
                // this.uploadids=[]
            }
        },
        resetDummyForm() {
            this.dummyForm = {
                name: '',
                mobile: '',
                altmobile: ''
            }
            this.dummyMobileDuplicate = false
            this.dummyAltMobileDuplicate = false
            this.dummyMobileEditing = true
            this.dummyAltMobileEditing = true
            this.originalDummyMobile = ''
            this.originalDummyAltMobile = ''
            this.awardDummyReferralPoints = false
        },
        checkvalidationaccess() {
            if (this.loginusercheck(123)) {
                this.validateadhar = false
            }
        },
        stripCountryCode(value) {
            const digits = (value ?? '').toString().replace(/\D/g, '')
            if (digits.length > 10) {
                return digits.slice(-10)
            }
            return digits
        },
        formatMobileDisplay(value) {
            return this.stripCountryCode(value)
        },
        handleDummyMobileInput(field) {
            this.normalizeDummyMobile(field)
            this.checkDummyDuplicate(field)
        },
        editDummyMobile(field) {
            if (field == 'mobile') {
                this.dummyMobileEditing = true
            } else {
                this.dummyAltMobileEditing = true
            }
            this.dummyForm[field] = this.stripCountryCode(this.dummyForm[field])
        },
        doneDummyMobile(field) {
            this.normalizeDummyMobile(field)
            if (field == 'mobile') {
                this.dummyMobileEditing = false
            } else {
                this.dummyAltMobileEditing = false
            }
        },
        clearDummyMobile(field) {
            this.dummyForm[field] = ''
            if (field == 'mobile') {
                this.dummyMobileEditing = true
                this.dummyMobileDuplicate = false
            } else {
                this.dummyAltMobileEditing = true
                this.dummyAltMobileDuplicate = false
            }
        },
        resetCustomerForm() {
            this.form = new window.Form({
                id: 0,
                name: '',
                adhar: 0,
                sponser_type: 0,
                registation_type: 0,
                parentid: 0,
                relation: '',
                mobiles: null,
                addressess: null,
                idproofs: null,
                s_income: 1,
                m_status: 1,
                marrigedate: null,
                occupation: '',
                religion: 1,
                gender: 1,
                dob: '',
                registation_date: '',
                relationship_type: 1,
                zoneid: 1,
                location: '',
                distance: 0,
                cus_hint: '',
                document_type: 1,
                iscustomer: 1,
                w_name: '',
                profileimage: null,
                email: '',
                documentvalue: '',
                pan: '',
                residence: 0,
                dor: '',
                customer_type: '',
                creditlimit: '',
                paymentmodeid: 0,
                verifiedbyid: 0,
                latitude: '',
                longitude: '',
                refername: '',
                refermobileno: '',
                referaddress: '',
                referrelation: '',
                professionid: 0
            })
            this.resetDummyForm()
            this.$store.commit('assignmobiles', [])
            this.$store.commit('assignaddressess', [])
            this.$store.commit('assignselectedaddress', null)
            this.$store.commit('assignselectedwaddress', null)
            this.$store.commit('assignprofileimage', null)
            this.$store.commit('assignidproofs', [])
            this.$store.commit('assignuploadids', [])
            this.$store.commit('assignreferraluser', null)
            this.awardDummyReferralPoints = false
            this.formresetkey += 1
        },
        normalizeDummyMobile(field) {
            let digits = (this.dummyForm[field] ?? '').toString().replace(/\D/g, '')
            if (digits.length > 10) {
                digits = digits.startsWith('91') ? digits.slice(-10) : digits.slice(0, 10)
            }
            this.dummyForm[field] = digits
        },
        async checkDummyDuplicate(field) {
            this.normalizeDummyMobile(field)
            if (field == 'mobile') {
                this.dummyMobileDuplicate = false
            } else {
                this.dummyAltMobileDuplicate = false
            }

            const mobile = this.dummyForm[field]
            if (mobile == null || mobile.length < 10) {
                return
            }

            if (
                (field == 'mobile' && mobile == this.originalDummyMobile) ||
                (field == 'altmobile' && mobile == this.originalDummyAltMobile)
            ) {
                if (field == 'mobile') {
                    this.dummyMobileDuplicate = false
                } else {
                    this.dummyAltMobileDuplicate = false
                }
                return
            }

            if (
                this.dummyForm.mobile != '' &&
                this.dummyForm.altmobile != '' &&
                this.dummyForm.mobile == this.dummyForm.altmobile
            ) {
                this.dummyMobileDuplicate = true
                this.dummyAltMobileDuplicate = true
                return
            }

            try {
                let param = { mobileno: '+91' + mobile, alternatemobile: '+91' + mobile }
                let response = await this.$http.post('api/user/checkforcustomer', param)
                if (field == 'mobile') {
                    this.dummyMobileDuplicate = response.data?.user != null
                } else {
                    this.dummyAltMobileDuplicate = response.data?.user != null
                }
            } catch (error) {
                console.log('Duplicate check failed', error)
            }
        },
        buildDummyPayload() {
            this.form.name = this.dummyForm.name.trim()
            this.form.addressess = this.addressess
            this.form.mobiles = [
                { id: 0, mobile: this.dummyForm.mobile, appid: 'vsdigi' },
                { id: 0, mobile: this.dummyForm.altmobile, appid: 'vsdigi' }
            ]
            this.form.registation_type = 3
            this.form.registation_date = this.form.registation_date || this.getCurrentDate()
        },
        getCurrentDate() {
            const today = new Date()
            const year = today.getFullYear()
            const month = String(today.getMonth() + 1).padStart(2, '0')
            const day = String(today.getDate()).padStart(2, '0')
            return `${year}-${month}-${day}`
        },
        async submit() {
            this.checkvalidationaccess()
            this.clickpdf = true
            if (this.isDummyRegistration) {
                this.awardDummyReferralPoints = this.edititem == null || this.edititem.id == 0
                this.form.parentid = this.referraluser == null ? 0 : this.referraluser.id
                if (this.dummyForm.name.trim() == '') {
                    this.clickpdf = false
                    alert('Customer Name must be filled')
                } else if (this.form.parentid == 0) {
                    this.clickpdf = false
                    alert("Introducer Can Not be empty")
                } else if (this.mobiles == null || this.mobiles.length == 0) {
                    this.clickpdf = false
                    alert('Mobile No. can not be empty')
                } else if (this.addressess == null || this.addressess.length == 0) {
                    this.clickpdf = false
                    alert('Address must be filled')
                } else if (this.addressess[0]?.zipcode == '') {
                    this.clickpdf = false
                    alert('Pincode must be filled')
                } else {
                    //this.buildDummyPayload()
                    this.form.name = this.dummyForm.name.trim()
                    this.form.mobiles = this.mobiles
                    this.form.addressess = this.addressess
                    this.form.registation_type = 3
                    this.$store.commit('assignloadingstatus', 1)
                    if (this.profileimage != null && this.form.profileimageid != this.profileimage.id)
                        this.form.profileimage = this.profileimage
                    this.form.idproofs = this.uploadids
                    this.form.submit(this, 'post', 'api/profile/createupdate')
                        .then(response => this.processResponse(response))
                        .catch(error => this.errordisplay(error));
                }
            }
            else {
                this.form.mobiles = this.mobiles
                this.form.addressess = this.addressess
                this.form.parentid = this.referraluser == null ? 0 : this.referraluser.id
                if (this.form.parentid == 0) {
                    this.clickpdf = false
                    alert("Introducer Can Not be empty")
                } else if (!this.form.mobiles.length > 0) {
                    this.clickpdf = false
                    alert("Mobile No. can not be empty")
                } else if (this.validateadhar && this.form.adhar == 0) {
                    this.clickpdf = false
                    alert("Adhar Card Must be filled")
                } else if (this.form.registation_date == '') {
                    this.clickpdf = false
                    alert("Registration Date Must be filled")
                } else if (this.form.verifiedbyid == 0) {
                    this.clickpdf = false
                    alert("Verified by must be filled")
                } else if (this.form.relation == '') {
                    this.clickpdf = false
                    alert("SO-WO-DO by must be filled")
                } else if (this.form.dob == '') {
                    this.clickpdf = false
                    alert("Date of Birth by must be filled")
                }
                else if (this.form?.addressess[0]?.zipcode == '') {
                    this.clickpdf = false
                    alert("Pincode is compulsory")
                }
                else {
                    this.$store.commit('assignloadingstatus', 1)
                    if (this.profileimage != null && this.form.profileimageid != this.profileimage.id)
                        this.form.profileimage = this.profileimage
                    this.form.idproofs = this.uploadids
                    this.form.submit(this, 'post', 'api/profile/createupdate')
                        .then(response => this.processResponse(response))
                        .catch(error => this.errordisplay(error));
                }
            }
        },
        errordisplay(error) {
            if (error?.errors?.registation_type?.length) {
                this.$store.commit('assignloadingstatus', 0)
                this.clickpdf = false
                this.$notify({ text: error.errors.registation_type[0], type: 'error' })
                return
            }
            console.log("Error", error?.errors?.mobiles)
            this.$store.commit('assignloadingstatus', 0)

            setTimeout(() => {
                this.clickpdf=false
            }, 3000); 

            console.log("in mobile ")
            this.$notify({
                text: error?.errors?.mobiles[0],
                type: 'error',
                duration: '80000',
                speed: '500',
                closeOnClick: false

            })
            this.$notify({
                text: error?.errors?.adhar[0],
                type: 'error',
                duration: '80000',
                speed: '500',
                closeOnClick: false

            })
            
        },
        async processResponse(data) {
            this.$store.commit('updateappendcustomers', data.user)
            if (this.isDummyRegistration && this.awardDummyReferralPoints && data.user?.parentid > 0) {
                await this.saveDummyReferralPoints(data.user.parentid)
            }
            this.$store.commit('assignviewno', 1)
            this.$notify({
                text: 'Customer Registered Successfully',
                type: 'success',
                duration: '80000',
                speed: '500',
                closeOnClick: false
            })
            this.resetCustomerForm();
            this.$store.commit('assignloadingstatus', 0)
            setTimeout(() => {
                this.clickpdf = false
            }, 2000);
        },
        keydownform(event) {
            this.form.errors.clear(event.target.name);
            this.errormessage = '';
        },

        cancel() {
            this.resetCustomerForm();
            this.$store.commit('assignviewno', 1)
            this.$store.commit('assignloadingstatus', 0)
        },
        uploaded() {
            this.$store.commit('assignprofileimage', this.uploadedimage)
        },
        fetchReferralPointAmount() {
            this.$http.post('api/company/detail')
                .then(response => {
                    let company = response.data?.company
                    let points = 0
                    try {
                        points = JSON.parse(company?.paramjson ?? '{}')?.points ?? 0
                    } catch (error) {
                        points = 0
                    }
                    this.referralPointAmount = parseFloat(points) || 0
                })
                .catch(error => {
                    console.log('Failed to load referral point amount', error)
                    this.referralPointAmount = 0
                })
        },
        async saveDummyReferralPoints(parentid) {
            if (parseFloat(this.referralPointAmount) <= 0) {
                return
            }

            try {
                await this.$http.post('api/manual/points/save', {
                    customerid: parentid,
                    transactiondate: new Date().toISOString().slice(0, 10),
                    storeid: this.selectedstoreid ?? 0,
                    amount: this.referralPointAmount
                })
            } catch (error) {
                console.log('Failed to save referral points', error)
                this.$notify({
                    text: 'Customer saved, but referral points could not be added.',
                    type: 'warning',
                    duration: '80000',
                    speed: '500',
                    closeOnClick: false
                })
            }
        }

    }

}
</script>
<style>
.adhar-validate-success {
    color: rgb(23, 152, 10);
    font-size: 45px;
    position: absolute;
    top: 0;
    right: 13px;
}

.adhar-validate-error {
    color: rgb(152, 10, 10);
    font-size: 45px;
    position: absolute;
    top: 0;
    right: 13px;
}

</style>
